module.exports = __webpack_public_path__ + "static/media/oral-care.a0b6ce8e.webp";